// Imports
import './index.css';
import { Api } from '../components/Api.js'
import { 
    config,
    profileEditButton,
    popupInputUserName,
    popupInputOccupation,
    buttonNewItemOpen,
    formList,
    buttonEditAvatar,
    profileAvatarBlock,
} from '../utils/constants.js';
import { Card } from '../components/Сard.js'
import { FormValidator } from '../components/FormValidator.js';
import { PopupWithForm } from '../components/PopupWithForm.js';
import { UserInfo } from '../components/UserInfo.js';
import { PopupWithImage } from '../components/PopupWithImage.js'
import { Section } from '../components/Section.js';
import { PopupWithConfirmation } from '../components/PopupWithConfirmation.js';

let userId;
//========================================================================================
const api = new Api({
    url: 'https://mesto.nomoreparties.co/v1/cohort-65',
    headers: {
        authorization: '1513e1ce-293c-41a3-bbe1-1734a1dc9636',
        'Content-Type': 'application/json'
    }
});
//========================================================================================
// Cards rendering function:
//========================================================================================
Promise.all([api.getUserInformation(), api.getInitialCards()])
.then(([profile, cards]) => {
    userInfo.setUserInfo({ newUserName: profile.name, newUserOccupation: profile.about });
    userInfo.setNewAvatar({ newUserAvatar: profile.avatar });
    userId = profile._id;
    section.renderItems(cards.reverse()); 
})
.catch(error => console.log(`Error: ${error.status}`));
//========================================================================================
// Edit profile:
//========================================================================================
// User info:
const userInfo = new UserInfo({ 
    profileNameSelector: '.profile__user-name', 
    profileOccupationSelector: '.profile__user-occupation',
    profileAvatarSelector: '.profile__avatar',
});
// Popup - Edit profile:
const popupEditProfile = new PopupWithForm({
    popupSelector: '.popup_type_user', 
    defaultText: 'Сохранить',
    submitCallbackFunction: (inputValues) => {
        const {
            'popup-username': userName,
            'popup-occupation': userOccupation,
        } = inputValues;
        // Сохранение...
        popupEditProfile.isLoadingText(true);
        // Sending request to update profile information on server:
        return api
        .sendProfileInformation({ name: userName, about: userOccupation })
        .then(() => {
            userInfo.setUserInfo({ newUserName: userName, newUserOccupation: userOccupation });
        })
        .then(popupEditProfile.close())
        .catch(error => `Error: ${error.status}`)
        .finally(() => {
            popupEditProfile.isLoadingText(false);
        });
    }
});
popupEditProfile.setEventListeners();
// Button edit profile:
profileEditButton.addEventListener('click', () => {
    popupEditProfile.open();
    formValidators['profile-form'].clearInputErrors();
    const { name: nameHtmlContent, occupation: occupationHtmlContent } = userInfo.getUserInfo(); 
    popupInputUserName.value = nameHtmlContent;
    popupInputOccupation.value = occupationHtmlContent;

});
//========================================================================================
// Add places:
//========================================================================================
const popupAddPlace = new PopupWithForm({
    popupSelector: '.popup_type_item',
    defaultText: 'Сохранить',
    submitCallbackFunction: (inputValues) => {
        const {
            'popup-image-name': name,
            'popup-image-link': link,
        } = inputValues;
        // Сохранение...
        popupAddPlace.isLoadingText(true);
        // Sending request to post new card on server:
        return api
        .addNewCard({ name, link })
        .then(renderCard)
        .then(popupAddPlace.close())
        .catch(error => console.log(`Error: ${error}`))
        .finally(() => {
            popupAddPlace.isLoadingText(false);
        });
    }
});
popupAddPlace.setEventListeners();
// Button to open new item form:
buttonNewItemOpen.addEventListener('click', () => {
    popupAddPlace.open();
    formValidators['place-form'].disableButton();
    formValidators['place-form'].clearInputErrors();
});
//========================================================================================
// Click on image to open fullscreen:
//========================================================================================
const popupWithImage = new PopupWithImage({ popupSelector: '.popup_type_image' });
popupWithImage.setEventListeners();
//========================================================================================
// Delete card from page:
//========================================================================================
const popupWithConfirmation = new PopupWithConfirmation ({ popupSelector: '.popup_type_areyousure', defaultText: 'Да' })
popupWithConfirmation.setEventListeners();
const handleDeleteIconClick = card => {
    const submitFormConfirm = () => {
        // Удаляю...
        popupWithConfirmation.isDeletingText(true);
        return api
        .removeCard(card.getCardId())
        .then(card.removeCard())
        .then(popupWithConfirmation.close())
        .catch(error => console.log(`Error: ${error}`))
        .finally(() => {
            popupWithConfirmation.isDeletingText(false);
        })
        
    }
    popupWithConfirmation.setSubmitAction(submitFormConfirm);
    popupWithConfirmation.open();
}
//========================================================================================
// Render cards function:
//========================================================================================
const section = new Section({ renderer: renderCard }, '.places');

function renderCard(item) {
    const card = new Card({
        data: item,
        templateSelector: '#cardTemplate',
        userId: userId,
        handleCardClick: (name, link) => popupWithImage.open({ name, link }),
        handleCardLikes: (() => {
            if(card.isLiked) {
                return api
                .removeLikes(item._id)
                .then(response => response.likes.length)
                .then((result) => {
                    card.countingCardLikes(result);
                    card.dislike();
                })
                .catch(error => console.log(`Error: ${error.status}`))
            } else {
                return api
                .addLikes(item._id)
                .then(response => response.likes.length)
                .then((result) => {
                    card.countingCardLikes(result);
                    card.like();
                })
                .catch(error => console.log(`Error: ${error.status}`))
            }
        }),
        handleDeleteIconClick,
    });
    const cardElement = card.generateCard();
    section.addItem(cardElement);
}
//========================================================================================
// Inputs validation:
//========================================================================================
const formValidators = {}
const enableValidation = (config) => {
    formList.forEach((form) => {
        const validator = new FormValidator(config, form);
        const formName = form.getAttribute('name');
        formValidators[formName] = validator;
        validator.enableValidation();
    });
};
enableValidation(config);
//========================================================================================
// Change avatar image:
//========================================================================================
const popupWithAvatarImage = new PopupWithForm({
    popupSelector: '.popup_type_avatar-image',
    defaultText: 'Сохранить',
    submitCallbackFunction: (inputValues) => {
        const {
            'popup-avatar-image-link': avatar,
        } = inputValues;
        // Сохранение...
        popupWithAvatarImage.isLoadingText(true);
        // Sending request to post new card on server:
        return api
        .changeAvatarImage({ avatar })
        .then((response) => response.avatar)
        .then((url) => userInfo.setNewAvatar({newUserAvatar: url}))
        .then(popupWithAvatarImage.close())
        .catch(error => `Error: ${error.status}`)
        .finally(() => {
            popupWithAvatarImage.isLoadingText(false);
        });
    }
});
popupWithAvatarImage.setEventListeners();
profileAvatarBlock.addEventListener('click', () => {
    popupWithAvatarImage.open();
})
profileAvatarBlock.addEventListener('mouseover', () => {
    buttonEditAvatar.style.visibility = 'visible';
    profileAvatarBlock.style.opacity = '0.8'
});
profileAvatarBlock.addEventListener('mouseout', () => {
    buttonEditAvatar.style.visibility = 'hidden';
    profileAvatarBlock.style.opacity = '1'
    buttonEditAvatar.style.transition = 'visibility 0.2s ease-in';
    profileAvatarBlock.style.transition = 'opacity 0.35s ease';
})
//========================================================================================